<div class="check-indicator text-center" role="alert" *ngIf="expired | async">
  <nb-card class="b-material">
    <nb-card-body>
      <div class="mx-2 row align-items-start">
        <p class="h5">Tiempo Agotado</p>
      </div>
      <div class="mx-2 mt-1 row">
        <p>Tu sesi&oacute;n est&aacute; por terminar en {{60 - curSec}} segundos</p>
        <p>¿Todav&iacute;a est&aacute;s ahi?</p>
      </div>
      <div class="mx-2 row float-right">
        <button type="button" class="btn btn-primary" (click)="refreshToken()">Si, ac&aacute; estoy</button>
      </div>
    </nb-card-body>
  </nb-card>
</div>
